/*!

=========================================================
* Material Kit PRO React - v1.10.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from 'react';
import { Router, Route, Switch } from "react-router";

import "assets/scss/material-kit-pro-react.scss?v=1.10.0";

// pages for this product

import ErrorPage from "views/ErrorPage/ErrorPage.js";


// trade customer new pages
import EditCustomerPage from "trade-customer-portal/views/AdminPage/EditCustomerAreaPage.js"; // not being used
import AdminPage from "trade-customer-portal/views/AdminPage/AdminPage.js"; // not being used

import LandingPagePortal from "trade-customer-portal/views/LandingPage/LandingPage.js";

import OrderProcessPage from "trade-customer-portal/views/OrderProcessPage/OrderProcessPage.js";
import ReviewOrderPage from "trade-customer-portal/views/ReviewOrderPage/ReviewOrderPage.js";
import OrderProcessPageTwo from "trade-customer-portal/views/OrderProcessPage/Sections/StageTwo/OrderPorcessStageTwoPage.js";
import OrderProcesConfirmation from "trade-customer-portal/views/OrderProcessPage/Sections/OrderConfirmation/OrderProcessConfirmation.js";
import ContactUsPageNew from "trade-customer-portal/views/ContactUsPage/ContactUsPage.js";
import McCannLogIn from "trade-customer-portal/views/LogInPage/LogInPage.js";

import McCannRegister from "trade-customer-portal/views/RegisterPage/RegisterPage";
import EmailConfirmationPage from "trade-customer-portal/views/EmailConfirmationPage/EmailConfirmationPage.js";
import ErrorCustomPage from "trade-customer-portal/views/errorCustomPage.js";
import OrderPaymentPage from "trade-customer-portal/views/OrderProcessPage/Sections/StageThree/OrderPaymentPage.js";

import ForgottenPassowrdPage from "trade-customer-portal/views/ForgottenPasswordPage/ForgottenPasswordPage.js";



import UpdateAccountPage from "trade-customer-portal/views/RegisterPage/UpdateUserPage.js";




import AuthorizeRoute from "./components/api-authorization/AuthorizeRoute";
import ApiAuthorizationRoutes from './components/api-authorization/ApiAuthorizationRoutes';
import { ApplicationPaths } from './components/api-authorization/ApiAuthorizationConstants';





//var hist = createBrowserHistory();

export default class App extends Component {
    static displayName = App.name;
    render() {
        return (
            /*        <Router history={history}>*/
            <Switch>
                {/*<Route path="/about-us" component={AboutUsPage} />*/}
                {/*<Route path="/blog-post" component={BlogPostPage} />*/}
                {/*<Route path="/blog-posts" component={BlogPostsPage} />*/}
                {/*<Route path="/components" component={ComponentsPage} />*/}
                {/*<Route path="/contact-us" component={ContactUsPage} />*/}
                {/*<Route path="/ecommerce-page" component={EcommercePage} />*/}
                {/*<Route path="/landing-page" component={LandingPage} />*/}
                {/*<Route path="/login-page" component={LoginPage} />*/}
                {/*<Route path="/pricing" component={PricingPage} />*/}
                {/*<Route path="/profile-page" component={ProfilePage} />*/}
                {/*<Route path="/product-page" component={ProductPage} />*/}
                {/*<Route path="/sections" component={SectionsPage} />*/}
                {/*<Route path="/shopping-cart-page" component={ShoppingCartPage} />*/}
                {/*<Route path="/signup-page" component={SignupPage} />*/}
                {/*<Route path="/error-page" component={ErrorPage} />*/}


                {/*ADMIN SIDE BEING DEVELOPED ON QLOAD SIDE*/}
                {/*<AuthorizeRoute path="/editCustomer-page" component={EditCustomerPage} />*/}
                {/*<AuthorizeRoute path="/admin-page" component={AdminPage} />*/}


                {/*<AuthorizeRoute path="/landing-pagePortal" component={LandingPagePortal} />*/}
                {/*<AuthorizeRoute path="/admin-page" component={AdminPage} />*/}
                <AuthorizeRoute path="/OrderForm" component={OrderProcessPage} />
                <AuthorizeRoute path="/ReviewOrder" component={ReviewOrderPage} />
                <AuthorizeRoute path="/OrderSummary" component={OrderProcessPageTwo} />
                <AuthorizeRoute path="/OrderConfirmation" component={OrderProcesConfirmation} />
                <AuthorizeRoute path="/ContactUs" component={ContactUsPageNew} />
                <Route path="/Login" component={McCannLogIn} />
                {/*<AuthorizeRoute path="/editCustomer-page" component={EditCustomerPage} />*/}
                <Route path="/Register" component={McCannRegister} />
                <Route path="/emailConfirmation-page/" component={EmailConfirmationPage} />
                {/*<Route path="/error404-page" component={ErrorCustomPage} />*/}
                <Route path="/forgottenPassowrdPage-page/" component={ForgottenPassowrdPage} />

                <AuthorizeRoute path="/error-page" component={ErrorPage} />

                <AuthorizeRoute path="/EditAccount" component={UpdateAccountPage} />




                <AuthorizeRoute path="/OrderPayment" component={OrderPaymentPage} />



                <Route path={ApplicationPaths.ApiAuthorizationPrefix} component={ApiAuthorizationRoutes} />

                <AuthorizeRoute path="/" component={LandingPagePortal} />
            </Switch>
            /*</Router>*/

        );
    }
}
